import React from 'react';
import PropTypes from 'prop-types';
import { Divider, NumberFormatter } from '@mantine/core';
import ResponsiveModal from '../../common/ResponsiveModal';
import AppStack from '../../common/AppStack';
import AppText from '../../common/AppText';
import AppFlexbox from '../../common/AppFlexbox';
import { PAYMENT_TYPE_LIST } from '../../../config/constants';

const AdminStoreEscrowPaymentConfirmModal = ({
  isOpen,
  onClose,
  loading,
  onSubmit,
  transactionId,
  fkRegFormSubmissionPaymentType,
  storeEscrowSummary
}) => {
  const claimableBalance = storeEscrowSummary
    ? storeEscrowSummary.escrowEarned - storeEscrowSummary.escrowAmountClaimed
    : 0;

  return (
    <ResponsiveModal
      formSectionProps={{
        onCancel: onClose,
        isLoading: loading,
        onSubmit,
        isSubmitDisabled: claimableBalance <= 0,
        submitTitle: 'Yes, record payment',
        padding: 0
      }}
      isOpen={isOpen}
      onClose={onClose}
      size={500}
      title="Record escrow payment"
    >
      <AppStack style={{ gap: 0 }}>
        <AppFlexbox
          style={{
            flex: 1,
            padding: 16,
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <AppText
            style={{
              fontSize: 14,
              color: '#666',
              textAlign: 'center',
              fontStyle: 'italic'
            }}
          >
            Are you sure you want to record the following escrow payment?
          </AppText>
        </AppFlexbox>

        <AppStack style={{ gap: 0 }}>
          <Divider />

          <AppStack
            style={{ gap: 16, padding: 16, backgroundColor: '#f1f1f1' }}
          >
            <AppFlexbox
              style={{
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <AppText style={{ fontSize: 14, fontWeight: 500 }}>Total</AppText>

              <NumberFormatter
                decimalScale={2}
                fixedDecimalScale
                prefix="$"
                style={{ fontSize: 14, fontWeight: 500 }}
                thousandSeparator
                value={claimableBalance / 100}
              />
            </AppFlexbox>
          </AppStack>

          <Divider />

          <AppStack style={{ gap: 16, padding: 16 }}>
            <AppFlexbox
              style={{
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <AppText style={{ fontSize: 14 }}>Payment Type</AppText>

              <AppText style={{ fontSize: 14, color: '#666' }}>
                {
                  PAYMENT_TYPE_LIST.find(
                    (t) => t.value === fkRegFormSubmissionPaymentType
                  )?.label
                }
              </AppText>
            </AppFlexbox>
          </AppStack>

          <Divider />

          <AppStack style={{ gap: 16, padding: 16 }}>
            <AppFlexbox
              style={{
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <AppText style={{ fontSize: 14 }}>Transaction ID</AppText>

              <AppText style={{ fontSize: 14, color: '#666' }}>
                {transactionId}
              </AppText>
            </AppFlexbox>
          </AppStack>

          <Divider />

          <AppStack style={{ gap: 16, padding: 16 }}>
            <AppFlexbox
              style={{
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <AppText style={{ fontSize: 14 }}>Store</AppText>

              <AppText style={{ fontSize: 14, color: '#666' }}>
                {storeEscrowSummary.ecomStore.name}
              </AppText>
            </AppFlexbox>
          </AppStack>
        </AppStack>
      </AppStack>
    </ResponsiveModal>
  );
};

AdminStoreEscrowPaymentConfirmModal.propTypes = {
  fkRegFormSubmissionPaymentType: PropTypes.string,
  isOpen: PropTypes.bool,
  loading: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  storeEscrowSummary: PropTypes.object,
  transactionId: PropTypes.string
};

export default AdminStoreEscrowPaymentConfirmModal;
